import React from 'react';
import {Row, Col, Card} from 'react-materialize';

import which_mask from '../../images/which_mask.png';
import non_sururgical_mask from '../../images/non_sururgical_mask.png';
import how_to_use from '../../images/how_to_use.png';
import care_mask from '../../images/care_mask.png';
import fabric_mask from '../../images/fabric_mask.png';
import mask_disposal from '../../images/mask_disposal.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"masks_title"} defaultMessage={"O que você deve saber sobre máscaras"}/></b></p></h5>
            </div>
        </Row>

        <Row align="center">
            <div style={{display: 'inline-flex', alignItems: 'center', margin:"10px"}}>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/which_mask"} style={{background:'white', color: 'black'}}>
                        <img src={which_mask} className={"img"} alt={"Qual máscara eu devo usar?"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"which_mask_title"} defaultMessage={"Qual máscara eu devo usar?"}/></b></p>
                    </a>
                </div>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/non_sururgical_mask"} style={{background:'white', color: 'black'}}>
                        <img src={non_sururgical_mask} className={"img"} alt={"Máscaras não cirúrgicas"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"non_sururgical_mask_title"} defaultMessage={"Máscaras não cirúrgicas"}/></b></p>
                    </a>
                </div>
            </div>
        </Row>

        <Row align="center">
            <div style={{display: 'inline-flex', alignItems: 'center', margin:"10px"}}>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/how_to_use_it"} style={{background:'white', color: 'black'}}>
                        <img src={how_to_use} className={"img"} alt={"Como usá-la?"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"how_to_use_it_title"} defaultMessage={"Como usá-la?"}/></b></p>
                    </a>
                </div>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/care_mask"} style={{background:'white', color: 'black'}}>
                        <img src={care_mask} className={"img"} alt={"Cuidado com o uso da máscara"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"care_mask_title"} defaultMessage={"Cuidado com o uso da máscara"}/></b></p>
                    </a>
                </div>
            </div>
        </Row>

        <Row align="center">
            <div style={{display: 'inline-flex', alignItems: 'center', margin:"10px"}}>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/fabric_mask"} style={{background:'white', color: 'black'}}>
                        <img src={fabric_mask} className={"img"} alt={"Cuidado com o uso da máscara de tecido"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"fabric_mask_title"} defaultMessage={"Cuidado com o uso da máscara de tecido"}/></b></p>
                    </a>
                </div>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/mask_disposal"} style={{background:'white', color: 'black'}}>
                        <img src={mask_disposal} className={"img"} alt={"Atenção ao descarte de máscaras"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"mask_disposal_title"} defaultMessage={"Atenção ao descarte de máscaras"}/></b></p>
                    </a>
                </div>
            </div>
        </Row>

        <Row>
            <div align="center" style={{marginTop:"50px"}}>
                <a href={"/covid"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>   

    </Card>

);

export default Sobre;